import { render } from "./VPAAMentoringDetailsDialog.vue?vue&type=template&id=aef17858"
import script from "./VPAAMentoringDetailsDialog.vue?vue&type=script&lang=js"
export * from "./VPAAMentoringDetailsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__